module.exports = __webpack_public_path__ + "media/images/tags-ec6079c2a947f9f1781aa3414b55f0bf.png";